The type of event, i.e. HirerRelationshipChanged. This corresponds to the `Event.typeCode` field in the GraphQL schema.
